import { render, staticRenderFns } from "./AddSettings.vue?vue&type=template&id=a8bff940"
import script from "./AddSettings.vue?vue&type=script&lang=js"
export * from "./AddSettings.vue?vue&type=script&lang=js"
import style0 from "./AddSettings.vue?vue&type=style&index=0&id=a8bff940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports